import useProjectStore from "../store/projectStore";
import useAuthStore from "../store/authStore";

/**
 * Returns readonly state for the currently active blade design.
 *
 *  isReadOnly     — true when edits must be blocked (released OR locked by other)
 *  isReleased     — design has been permanently released
 *  isLockedByOther — checked out by a different user
 */
export default function useBladeReadonly() {
  const activeDesign = useProjectStore((s) => s.activeDesign);
  const user = useAuthStore((s) => s.user);

  const isReleased = !!activeDesign?.is_released;
  const isLockedByOther =
    !!activeDesign?.checked_out_by_id &&
    activeDesign.checked_out_by_id !== user?.id;

  return {
    isReadOnly: isReleased || isLockedByOther,
    isReleased,
    isLockedByOther,
  };
}
